import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CommonTable from "../../common-components/common-tables/CommonTable";
import { CallIcon, EmailIcon, PersonIcon } from "../../../images/icons/icons";

const TrainerBCAEvaluationTable = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
}) => {
  const { trainerStatsLoading, trainerStatsError, trainerStatsData } =
    useSelector((state) => state.prospects);

  const iniTbDatas = {
    pagination: [],
    allData: [],
  };
  const [allTbDatas, setAllTbDatas] = useState(iniTbDatas);

  useEffect(() => {
    if (
      !trainerStatsLoading &&
      !trainerStatsError &&
      trainerStatsData?.status &&
      trainerStatsData?.data?.length > 0
    ) {
      setAllTbDatas((prevs) => ({
        ...prevs,
        allData: trainerStatsData.data,
        pagination:
          trainerStatsData?.pagination?.length > 0
            ? trainerStatsData.pagination
            : [],
      }));
    } else {
      setAllTbDatas(iniTbDatas);
    }
  }, [trainerStatsLoading, trainerStatsError, trainerStatsData]);

  const tbColumns = [
    {
      dataField: "trainer_id",
      text: "Trainer Info",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <PersonIcon />
              </span>
              <span className="tb-data">{row?.trainer_name || "NA"}</span>
            </div>

            {row?.trainer_mobile && (
              <div className="tb-flex">
                <span className="tb-data tb-info-icon">
                  <CallIcon />
                </span>
                <span className="tb-data">{row.trainer_mobile || ""}</span>
              </div>
            )}

            {row?.trainer_email && (
              <div className="tb-flex">
                <span className="tb-data tb-info-icon">
                  <EmailIcon />
                </span>
                <span className="tb-data lowercase">
                  {row.trainer_email || "NA"}
                </span>
              </div>
            )}
          </div>
        );
      },
    },
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (_, row) => {
        const gymName = row?.gym_name || "NA";
        const isLong = gymName.length > 45;

        return (
          <span className={`tb-data ${isLong ? "tb-data-long" : ""}`}>
            {gymName}
          </span>
        );
      },
    },
    {
      dataField: "assigned_members",
      text: "Assigned Members",
      centerAligned: true,
      formatter: (_, row) => {
        return (
          <span
            className="tb-data tb-link"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "view_details",
                filterType: "assigned_members",
                rowData: row,
              }))
            }
          >
            {row?.assigned_members || "0"}
          </span>
        );
      },
    },
    {
      dataField: "bca_pending",
      text: "BCA Pending",
      centerAligned: true,
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data tb-link ${
              parseInt(row?.bca_pending) > 0 ? "tb-badge not-assigned" : ""
            }`}
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "view_details",
                filterType: "bca_pending",
                rowData: row,
              }))
            }
          >
            {row?.bca_pending || "0"}
          </span>
        );
      },
    },
    {
      dataField: "first_bca_pending",
      text: "First BCA Pending",
      centerAligned: true,
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data tb-link ${
              parseInt(row?.first_bca_pending) > 0
                ? "tb-badge not-assigned"
                : ""
            }`}
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "view_details",
                filterType: "first_bca_pending",
                rowData: row,
              }))
            }
          >
            {row?.first_bca_pending || "0"}
          </span>
        );
      },
    },
    {
      dataField: "recurring_bca_pending",
      text: "Recurring BCA Pending",
      centerAligned: true,
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data tb-link ${
              parseInt(row?.recurring_bca_pending) > 0
                ? "tb-badge not-assigned"
                : ""
            }`}
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "view_details",
                filterType: "recurring_bca_pending",
                rowData: row,
              }))
            }
          >
            {row?.recurring_bca_pending || "0"}
          </span>
        );
      },
    },
    {
      dataField: "bca_completed",
      text: "BCA Completed",
      centerAligned: true,
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data tb-link ${
              parseInt(row?.bca_completed) > 0
                ? "tb-badge tb-badge-success"
                : ""
            }`}
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "view_details",
                filterType: "bca_completed",
                rowData: row,
              }))
            }
          >
            {row?.bca_completed || "0"}
          </span>
        );
      },
    },
    {
      dataField: "fitness_profile_completed",
      text: "Fitness Profile Completed",
      centerAligned: true,
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data tb-link ${
              parseInt(row?.fitness_profile_completed) > 0
                ? "tb-badge tb-badge-success"
                : ""
            }`}
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "view_details",
                filterType: "fitness_profile_completed",
                rowData: row,
              }))
            }
          >
            {row?.fitness_profile_completed || "0"}
          </span>
        );
      },
    },
    {
      dataField: "three_day_assigned",
      text: "3 Day Assigned",
      centerAligned: true,
      formatter: (_, row) => {
        return (
          <span
            className="tb-data tb-link"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "view_details",
                filterType: "three_day_assigned",
                rowData: row,
              }))
            }
          >
            {row?.three_day_assigned || "0"}
          </span>
        );
      },
    },
    {
      dataField: "three_day_completed",
      text: "3 Day Completed",
      centerAligned: true,
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data tb-link ${
              parseInt(row?.three_day_completed) > 0
                ? "tb-badge tb-badge-success"
                : ""
            }`}
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "view_details",
                filterType: "three_day_completed",
                rowData: row,
              }))
            }
          >
            {row?.three_day_completed || "0"}
          </span>
        );
      },
    },
    {
      dataField: "day1_count",
      text: "Day 1",
      centerAligned: true,
      formatter: (_, row) => {
        return (
          <span
            className="tb-data tb-link"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "view_details",
                filterType: "day1",
                rowData: row,
              }))
            }
          >
            {row?.day1_count || "0"}
          </span>
        );
      },
    },
    {
      dataField: "day2_count",
      text: "Day 2",
      centerAligned: true,
      formatter: (_, row) => {
        return (
          <span
            className="tb-data tb-link"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "view_details",
                filterType: "day2",
                rowData: row,
              }))
            }
          >
            {row?.day2_count || "0"}
          </span>
        );
      },
    },
    {
      dataField: "day3_count",
      text: "Day 3",
      centerAligned: true,
      formatter: (_, row) => {
        return (
          <span
            className="tb-data tb-link"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "view_details",
                filterType: "day3",
                rowData: row,
              }))
            }
          >
            {row?.day3_count || "0"}
          </span>
        );
      },
    },
    {
      dataField: "pt_prospect",
      text: "PT Prospect",
      centerAligned: true,
      formatter: (_, row) => {
        return (
          <span
            className="tb-data tb-link"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "view_details",
                filterType: "pt_prospect",
                rowData: row,
              }))
            }
          >
            {row?.pt_prospect || "0"}
          </span>
        );
      },
    },
    {
      dataField: "pt_converted",
      text: "PT Converted",
      centerAligned: true,
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data tb-link ${
              parseInt(row?.pt_converted) > 0 ? "tb-badge tb-badge-success" : ""
            }`}
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "view_details",
                filterType: "pt_converted",
                rowData: row,
              }))
            }
          >
            {row?.pt_converted || "0"}
          </span>
        );
      },
    },
  ];

  return (
    <div className="common-table-container tb-bordered mt15">
      <CommonTable
        tableData={allTbDatas.allData}
        tablePagination={allTbDatas.pagination}
        tableColumns={tbColumns}
        isPage={isPage}
        setIsPage={setIsPage}
        pageLimit={pageLimit}
        setPageLimit={setPageLimit}
        isLoading={trainerStatsLoading}
      />
    </div>
  );
};

export default TrainerBCAEvaluationTable;
